import { links } from './links';
import { NZ, AU } from '../../constants/country-codes';

export const Versions = {
  default: 'default',
};

/**
 * Returns a country and locale specific version for a ShipStation KB or other resource
 * @param {object} args
 * @param {string} args.linkId
 * @param {string} args.country Country Code (ES, DE, US, etc.)
 * @param {string} args.locale
 * @param {string} args.version
 * @returns {string} Fully composed URL (https://...)
 * @todo move the gtmBrand to an internal member
 */
const internalGetLink = ({ linkId, country, locale, version = Versions.default }) => {
  const link = links[linkId];
  if (!link) {
    return '';
  }

  const applicationLink = link.ShipStation; // all links are for ShipStation brand
  const defaultCountryAndLocaleArticle = applicationLink[version];
  const correctedCountry = country === NZ ? AU : country;

  return (
    applicationLink?.[correctedCountry]?.[locale] ||
    applicationLink?.[correctedCountry]?.[version] ||
    applicationLink?.[correctedCountry]?.default ||
    defaultCountryAndLocaleArticle ||
    ''
  );
};

/**
 * Returns a country and locale specific version for a ShipStation KB or other resource
 * @param {string} linkId
 * @param {string} country Country Code (ES, DE, US, etc.)
 * @param {string} locale
 * @param {string} version
 * @returns {string} Fully composed URL (https://...)
 */
export const getLink = (linkId, country, locale, version = Versions.default) => {
  return internalGetLink({
    linkId,
    country,
    locale,
    version,
  });
};
